import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

export const MoreArticlesText = styled.a<{ isArticleWidget?: boolean }>`
    font-size: ${p => (p.isArticleWidget ? '14px' : '16px')};
    color: ${p => p.theme.footerTextColor};
    opacity: 0.6;
    padding: 7px 10px;
    display: block;

    ${p => (p.isArticleWidget ? 'margin-top: 6px;' : '')};

    ${cssMediaQueryBreakpoints.medium} {
        font-size: 14px;
        padding: 6px 10px;
    }

    ${cssMediaQueryBreakpoints.small} {
        font-size: 13px;
        padding: 4px 8px;
    }
`
